import React, { useState } from 'react'
import { Wrapper, Panel, Card, TextFieldIcon, SelectFieldIcon } from '../../_components'
import  Axios  from 'axios'
import { CircularProgress } from '@material-ui/core'
import { Formik } from 'formik'
import Theme from '../../Theme'
import data from '../../fixtures'


export default function PaymentForm( ) {
  const [ submitting, setSubmitting ] = useState( false )

  const handleSubmit = async ( values ) => {
    await setSubmitting( true )
    let slug
    switch( localStorage.getItem( "paymentType" ) ) {
        case "water_fees":
            slug = "fiefoc_water_fees"
        break;
        case "membership":
            slug = "fiefoc_membership"
        break;
        case "shares":
            slug = "fiefoc_shares"
        break;
        default:
            break
    }
    try {
        const response = await Axios.post( `https://mis.nec.go.ug/api/auth/${slug}`, {
            farmerCode: values.farmerCode,
            farmerId: localStorage.getItem( "farmerId"),
            farmerName: values.name,
            ffsg: values.ffsg_code,
            blockNo: values.blockNo,
            amountPaid: values.amount_paid,
            amountPerShare: values.amountPerShare,
            season: values.season,
            plotNumber: values.plot_no,
            scheme: localStorage.getItem( "scheme" ) ,
            sharesNumber: values.sharesNo,
            createdBy: localStorage.getItem( "email" )
        } )
        if( response.data ) {
            alert( response.data?.message )
            await localStorage.setItem( "name", "payments" )
            return window.location.reload()
            
        }
        await setSubmitting( false )
    } catch (error) {
        await setSubmitting( false )
    }
  }

  return (
    <Wrapper>
       {localStorage.getItem( "paymentType" ) === "water_fees" && (
        <Card icon={Theme.PlusIcon} title={`Payment of Water User Fees Form for Farmer ${localStorage.getItem( "farmerName")} :  ${localStorage.getItem( "farmerCode")}`}>
            <Formik initialValues={{
                season: "",
                name: localStorage.getItem( "farmerName" ),
                farmerCode: localStorage.getItem( "farmerCode" ),
                blockNo: localStorage.getItem( "farmerBlockId" ),
                ffsg_code: localStorage.getItem( "farmerGroup" ),
                plot_no: localStorage.getItem( "farmerPlot" ),
                amount_paid: ""
            }}
            onSubmit={handleSubmit}>
            { ( { values, handleBlur, handleChange, handleSubmit } ) => {
                return (
                <form onSubmit={handleSubmit}>
                    <Panel label={`Water User Fees Payment Form`}>
                        <div className="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 gap-2">
                            <SelectFieldIcon 
                                name="season"
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={values.season}
                                label="Season"
                                required={true}
                                question="Choose Season"
                                options={data.seasons.map( item => {
                                    return { id: item.id, label: item.label, value: item.value }
                                } )}
                            />
                        </div>

                        {values.season?.length > 0 && 
                        ( <div className="grid md:grid-cols-2 lg:grid-cols-3 md:gap-2 lg:gap-3">
                            <TextFieldIcon 
                                name="name"
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={values.name}
                                disabled={true}
                                question="Registered Farmer Name" />

                            <TextFieldIcon 
                                name="farmerCode"
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={values.farmerCode}
                                label="Reg. No."
                                required={true}
                                disabled={true}
                                question="Farmer Registration Number"/>

                            <TextFieldIcon 
                                name="blockNo"
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={values.blockNo}
                                label="Block Number"
                                required={true}
                                disabled={true}
                                question="Farmer Block Number" />

                            <TextFieldIcon 
                                name="ffsg_code"
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={values.ffsg_code}
                                label="Farmer Group Name"
                                required={true}
                                disabled={true}
                                question="FFSG Name" />

                            <TextFieldIcon 
                                name="plot_no"
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={values.plot_no}
                                label="Plot No."
                                required={true}
                                disabled={true}
                                question="Farmer Plot Number" />

                            <div className="hidden md:block lg:block" />

                            <TextFieldIcon 
                                type="number"
                                name="amount_paid"
                                handleChange={handleChange} 
                                handleBlur={handleBlur}
                                value={values.amount_paid}
                                label="Amount Paid"
                                required={true}
                                disabled={false}
                                question="Amount Paid( UGX )" />
                          </div> ) }
                    </Panel>
                    {submitting ? (
                        <div className="flex items-center justify-center">
                            <CircularProgress size={24} color="primary" />
                        </div>
                    ):
                    (
                        <button type="submit" className="bg-green-700 px-5 py-2 mx-2 text-white text-sm rounded-sm">
                            {`Submit`}
                        </button>
                    )}
                </form>
                )
            } }
            </Formik>
        </Card>
       )} 

       {localStorage.getItem( "paymentType" ) === "membership" && (
        <Card icon={Theme.PlusIcon} title={`Payment of Membership Fees for Farmer ${localStorage.getItem( "farmerName")} :  ${localStorage.getItem( "farmerCode")}`}>
            <Formik initialValues={{
                name: localStorage.getItem( "farmerName" ),
                farmerCode: localStorage.getItem( "farmerCode" ),
                blockNo: localStorage.getItem( "farmerBlockId" ),
                ffsg_code: localStorage.getItem( "farmerGroup" ),
                plot_no: localStorage.getItem( "farmerPlot" ),
                amount_paid: ""
            }} 
            // validationSchema={validationSchema}
            onSubmit={handleSubmit}>
            { ( { values, handleBlur, handleChange, handleSubmit } ) => {
                return (
                <form onSubmit={handleSubmit}>
                    <Panel label={`Cooperative Society Membership Fees Payment Form`}>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 md:gap-2 lg:gap-3">
                        <TextFieldIcon 
                            name="name"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.name}
                            disabled={true}
                            question="Registered Farmer Name" />

                        <TextFieldIcon 
                            name="farmerCode"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.farmerCode}
                            label="Reg. No."
                            required={true}
                            disabled={true}
                            question="Farmer Registration Number"/>

                        <TextFieldIcon 
                            name="blockNo"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.blockNo}
                            label="Block Number"
                            required={true}
                            disabled={true}
                            question="Farmer Block Number" />

                        <TextFieldIcon 
                            name="ffsg_code"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.ffsg_code}
                            label="Farmer Group Name"
                            required={true}
                            disabled={true}
                            question="FFSG Name" />

                         <TextFieldIcon 
                            name="plot_no"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.plot_no}
                            label="Plot No."
                            required={true}
                            disabled={true}
                            question="Farmer Plot Number" />

                        <div className="hidden md:block lg:block" />

                        

                        <TextFieldIcon 
                            type="number"
                            name="amount_paid"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.amount_paid}
                            label="Amount Paid"
                            required={true}
                            disabled={false}
                            question="Amount Paid( UGX )" />
                    </div>
                    </Panel>
                    {submitting ? (
                        <div className="flex items-center justify-center">
                            <CircularProgress size={24} color="primary" />
                        </div>
                    ):
                    (
                        <button type="submit" className="bg-green-700 px-5 py-2 mx-2 text-white text-sm rounded-sm">
                            {`Submit`}
                        </button>
                    )}
                </form>
                )
            } }
            </Formik>
        </Card>
       )} 

      {localStorage.getItem( "paymentType" ) === "shares" && (
        <Card icon={Theme.PlusIcon} title={`Buying Shares for Farmer ${localStorage.getItem( "farmerName")} :  ${localStorage.getItem( "farmerCode")}`}>
            <Formik initialValues={{
                name: localStorage.getItem( "farmerName" ),
                farmerCode: localStorage.getItem( "farmerCode" ),
                blockNo: localStorage.getItem( "farmerBlockId" ),
                ffsg_code: localStorage.getItem( "farmerGroup" ),
                plot_no: localStorage.getItem( "farmerPlot" ),
                sharesNo: "",
                amountPerShare: "",
                amount_paid: ""
            }} 
            // validationSchema={validationSchema}
            onSubmit={handleSubmit}>
            { ( { values, handleBlur, handleChange, handleSubmit } ) => {
                return (
                <form onSubmit={handleSubmit}>
                    <Panel label={`Water User Fees Payment Form`}>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 md:gap-2 lg:gap-3">
                        <TextFieldIcon 
                            name="name"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.name}
                            disabled={true}
                            question="Registered Farmer Name" />

                        <TextFieldIcon 
                            name="farmerCode"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.farmerCode}
                            label="Reg. No."
                            required={true}
                            disabled={true}
                            question="Farmer Registration Number"/>

                        <TextFieldIcon 
                            name="blockNo"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.blockNo}
                            label="Block Number"
                            required={true}
                            disabled={true}
                            question="Farmer Block Number" />

                        <TextFieldIcon 
                            name="ffsg_code"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.ffsg_code}
                            label="Farmer Group Name"
                            required={true}
                            disabled={true}
                            question="FFSG Name" />

                         <TextFieldIcon 
                            name="plot_no"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.plot_no}
                            label="Plot No."
                            required={true}
                            disabled={true}
                            question="Farmer Plot Number" />

                        <div className="hidden md:block lg:block" />

                        <TextFieldIcon 
                            name="sharesNo"
                            type="number"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.sharesNo}
                            label="Shares No."
                            required={true}
                            disabled={false}
                            question="Number of Shares" />
                        
                        <TextFieldIcon 
                            type="number"
                            name="amountPerShare"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={values.amountPerShare}
                            label="Amount Per Share"
                            required={true}
                            disabled={false}
                            question="Amount Per Share( UGX )" />
                        
                        <div className="hidden md:block lg:block" />
                        
                        <TextFieldIcon 
                            type="number"
                            name="amount_paid"
                            handleChange={handleChange} 
                            handleBlur={handleBlur}
                            value={parseFloat( values.amountPerShare * values.sharesNo ) || 0}
                            label="Amount Paid"
                            required={true}
                            disabled={true}
                            question="Amount Paid( UGX )" />
                    </div>
                    </Panel>
                    {submitting ? (
                        <div className="flex items-center justify-center">
                            <CircularProgress size={24} color="primary" />
                        </div>
                    ):
                    (
                        <button type="submit" className="bg-green-700 px-5 py-2 mx-2 text-white text-sm rounded-sm">
                            {`Submit`}
                        </button>
                    )}
                </form>
                )
            } }
            </Formik>
        </Card>
       )} 
    </Wrapper>
  )
}
